import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type TranslatedStringSpecsFragment = (
  { __typename: 'TranslatedString' }
  & Pick<SchemaTypes.TranslatedString, 'defaultValue'>
  & { overrides: Array<(
    { __typename: 'TranslatedStringOverrides' }
    & Pick<SchemaTypes.TranslatedStringOverrides, 'value' | 'languagePackId'>
  )> }
);

export const TranslatedStringSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment TranslatedStringSpecs on TranslatedString {
  defaultValue
  overrides {
    value
    languagePackId
  }
}
    `;